var React = require('react');

function Quote1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon For Quote#1"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("rect",{"opacity":"0","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("polygon",{"fill":"#000000","points":"11 7 9 13 11 13 11 18 6 18 6 13 8 7","key":1}),React.createElement("polygon",{"fill":"#000000","opacity":"0.3","points":"19 7 17 13 19 13 19 18 14 18 14 13 16 7","key":2})])]);
}

Quote1.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Quote1;

Quote1.default = Quote1;
